import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { icons } from '../../../utils/icons';
import { colors } from '../../../styles/colors';
import { Regular } from '../../../components';

export const TestResultItem = ({ label, value, icon }) => (
  <Container>
    <img src={icons[icon]} alt={icon} />
    <Label>{label}</Label>
    <Value>{value}</Value>
  </Container>
);

TestResultItem.propTypes = {
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

const Container = styled.div`
  padding: 30px 0;
  margin-bottom: 1rem;
  text-align: center;
  background: ${colors.white};
  border-radius: 10px;
`;
const Label = styled(Regular)`
  padding-top: 13px;
  font-size: 18px;
  font-weight: normal;
  line-height: 26px;
  color: ${colors.blackAlpha(0.8)};
`;
const Value = styled(Regular)`
  font-size: 20px;
  font-weight: 600;
  line-height: 26px;
  color: ${colors.black};
`;
